import React from 'react';

import QuestionScore from '@ts-core/modules/exercises/components/QuestionScore';
import QuestionPreviewContainer from '@ts-core/modules/exercises/components/QuestionPreviewContainer';

import { FillInTheBlanksQuestionWithResults } from '../../types';

import FillInTheBlanksQuestionBlank from '../FillInTheBlanksQuestionBlank';
import FillInTheBlanksQuestionText from '../FillInTheBlanksQuestionText';

interface FillInTheBlanksQuestionPreviewProps {
  question?: FillInTheBlanksQuestionWithResults;
  loading?: boolean;
  hideScores?: boolean;

  hideQuestionBackgroundColor?: boolean;
}

const FillInTheBlanksQuestionPreview = (props: FillInTheBlanksQuestionPreviewProps) => {
  const { question, loading, hideScores, hideQuestionBackgroundColor } = props;
  const allSelectedOptionTypesAreEqual = !question?.selectedOptionType || new Set(question?.selectedOptionType || []).size === 1;
  const [optionType] = question?.selectedOptionType || [];

  return (
    <QuestionPreviewContainer
      sx={{ minHeight: 140 }}
      optionType={allSelectedOptionTypesAreEqual ? optionType : 'neutral'}
      noColors={hideQuestionBackgroundColor || loading}
    >
      <FillInTheBlanksQuestionText
        question={question}
        loading={loading}
        renderBlank={(blank, blankIndex) => {
          const answerType = question?.selectedOptionType?.[blankIndex];
          const answerText = question?.selectedOption?.[blankIndex]?.text || '';
          return <FillInTheBlanksQuestionBlank noColors answerText={answerText} answerType={answerType} blank={blank} />;
        }}
      />
      {!hideScores && !loading && <QuestionScore score={question?.score} noAnswer={!optionType} />}
    </QuestionPreviewContainer>
  );
};

export default FillInTheBlanksQuestionPreview;
